import React from 'react';
import { useInView } from 'react-intersection-observer';
import { AnalyticsContext } from 'telia-front-react';
import GaDataStore, { GaData } from '../stores/GaDataStore';

interface Props {
  children?: React.ReactNode;
  data: GaData;
  pushWhenVisible?: boolean;
}

const DEFAULT_DATA = {
  event: 'AutoEvent'
};

const GaPushOnMount = (props: Props): JSX.Element => {
  const analyticsContext = React.useContext(AnalyticsContext);

  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true
  });

  const pushAnalytics = () =>
    GaDataStore.pushWithoutCmsData({ ...DEFAULT_DATA, ...{ eventCategory: analyticsContext.page, eventGroup: analyticsContext.group }, ...props.data });

  React.useEffect(
    () => {
      const { pushWhenVisible } = props;

      if (pushWhenVisible && inView) {
        pushAnalytics();
      } else if (!pushWhenVisible) {
        pushAnalytics();
      }
    },
    props.pushWhenVisible ? [inView] : []
  );

  return <div ref={ref}>{props.children}</div>;
};

export default GaPushOnMount;
